import { api } from "@/lib/api";

export const needsPlan = (b) => !!b?.subscription_required && !["trialing", "active"].includes(b?.subscription?.status);
export const inr = (n) => `₹${Number(n || 0).toLocaleString("en-IN", { maximumFractionDigits: 2 })}`;
export const fmtDate = (s) => (s ? new Date(s).toLocaleDateString("en-IN", { day: "numeric", month: "short", year: "numeric" }) : "—");

export function quote(plan, cycle, seats) {
  const n = plan.max == null ? Math.max(plan.min, seats || plan.min) : plan.max;
  return { seats: n, yearlyPerSeat: plan.monthly * 12, amount: plan.monthly * n * (cycle === "yearly" ? 12 : 1) };
}

function loadRazorpay() {
  if (window.Razorpay) return Promise.resolve(true);
  return new Promise((resolve) => {
    const s = document.createElement("script");
    s.src = "https://checkout.razorpay.com/v1/checkout.js";
    s.onload = () => resolve(true);
    s.onerror = () => resolve(false);
    document.body.appendChild(s);
  });
}

// Opens Razorpay to authorise the mandate (no charge during the trial); resolves on success, rejects on failure/close.
export async function authorisePayment(start, business) {
  if (start.gateway !== "razorpay") return api.post("/subscription/verify", {});
  if (!(await loadRazorpay())) throw new Error("Couldn't load the payment window. Check your connection and retry.");
  const resp = await new Promise((resolve, reject) => {
    const rz = new window.Razorpay({
      key: start.razorpay_key_id, subscription_id: start.subscription.rzp_subscription_id,
      name: "RESTRO-VENDS", description: `${start.subscription.plan_name} plan · free trial`,
      prefill: { name: business?.owner_name, email: business?.business_email, contact: business?.owner_mobile },
      theme: { color: "#0D5C3A" }, handler: resolve, modal: { ondismiss: () => reject(new Error("Payment was cancelled")) },
    });
    rz.on("payment.failed", (r) => reject(new Error(r?.error?.description || "Payment failed")));
    rz.open();
  });
  return api.post("/subscription/verify", resp);
}
